import { Trans, useTranslation } from 'react-i18next';
import * as Styled from './AmountPlaceholder.styled';
import { getCurrencySymbol } from '../../../features/passport/getCurrencySymbol';
import { jsx as _jsx } from "react/jsx-runtime";
export const AmountPlaceholder = _ref => {
  let {
    currencyCode,
    locale
  } = _ref;
  const {
    t
  } = useTranslation('blocks.donation');
  const currencySymbol = getCurrencySymbol(currencyCode, locale);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Trans, {
      t: t,
      i18nKey: "AmountButton.amountPlaceholder",
      values: {
        currencySymbol
      },
      defaults: "<currency>{{currencySymbol}}</currency><placeholder>optimized</placeholder>",
      components: {
        currency: /*#__PURE__*/_jsx(Styled.CurrencySymbol, {}),
        placeholder: /*#__PURE__*/_jsx(Styled.PlaceholderText, {})
      }
    })
  });
};